export default __webpack_public_path__ + "static/wordcloud-b7964179592a3ca648f24ee34b4631b4.webp";